// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SectionComponent, GSGrid } from "@components";
import type { LoginRecord } from "@modules/employee/reducer/user-account-details/types";
import { formatDateTime } from "@transformers/date";

const APPLICATION_MAPPER = {
  "goodshape-central-fe-local": "GOOD_SHAPE_CENTRAL",
  "goodshape-central-fe": "GOOD_SHAPE_CENTRAL",
  "goodshape-health-fe": "GOODSHAPE_HEALTH",
  "mobile-app-react": "GOODSHAPE_MOBILE",
  "developer-hub-fe": "GOODSHAPE_DEVELOPER_HUB",
};

type Props = $Exact<{
  data: Array<LoginRecord>,
  ...PropsFromLocalize,
}>;

export class RecentLogins extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("DATE_TIME"),
        renderCell: ({ row }: { row: LoginRecord }) => formatDateTime(row.createdAt),
        key: "date",
      },
      { name: this.props.t("IP_ADDRESS"), key: "remoteAddr" },
      { name: this.props.t("BROWSER"), key: "userAgent", align: "left" },
      {
        name: this.props.t("APPLICATION"),
        key: "keycloakClientId",
        renderCell: ({ row }: { row: LoginRecord }) =>
          this.props.t(APPLICATION_MAPPER[row.keycloakClientId]),
      },
      {
        name: this.props.t("RESULT"),
        key: "status",
        renderCell: ({ row }: { row: LoginRecord }) => this.props.t(row.status),
      },
    ];
  }

  render() {
    return (
      <SectionComponent
        wrapperClassName="flex-column"
        title={<h5>{this.props.t("RECENT_LOGINS")}</h5>}
      >
        <GSGrid rows={this.props.data} columns={this.columns} />
      </SectionComponent>
    );
  }
}
export default localize()(RecentLogins);
